const debounce = require('throttle-debounce/debounce');
const templateVacancies = require('./vacancies.ejs');
const platform = require('platform');

class Vacancies {
	constructor(container) {
		this.container = container;
		this.containerFilterSelect = this.container.find('.js-select--vacancies');
		this.containerContent = this.container.find('.js-vacancies-content');
	}

	getParams() {
		return {
			ajax: true,
			current: parseInt(this.container.attr('data-vacancies-current')),
			department: this.containerFilterSelect.val(),
			lang: getLang()
		};
	}

	initSelect() {
		if (!(platform.name == 'IE' && parseInt(platform.version) < 11)) {
			this.containerFilterSelect
				.outerWidth('100%')
				.select2({
					theme: 'news-filter',
					minimumResultsForSearch: Infinity
				});
		}
	}

	create() {
		this.initSelect();

		this.container
			.find('.js-vacancies-loader')
			.on('click', (e) => {
				let current = parseInt(this.container.attr('data-vacancies-current')),
					total = parseInt(this.container.attr('data-vacancies-total'));

				if (current < total) {
					this.sendRequest();
				}
			});

		this.containerFilterSelect
			.on('change', debounce(100, (e) => this.sendRequest(true)));

		this.checkScroll();
	}

	checkScroll() {
		let self = this;
		let positionPoint = $(window).scrollTop();
		let bottomPoint = $(document).height() - $(window).height() - $(document).find('.footer').outerHeight();

		if (positionPoint >= bottomPoint) {
			let current = parseInt(self.container.attr('data-vacancies-current')),
				total = parseInt(self.container.attr('data-vacancies-total'));

			if (current < total) {
				self.sendRequest();
			}
		}
	}

	sendRequest(firstLoad = false) {
		const dataAjaxPath = this.container.attr('data-ajax-path');
		const $preloader = '<div class="preloader"></div>';

		let params = this.getParams();
		let self = this;

		self.container
			.find('.js-vacancies-loader')
			.hide();

		if (firstLoad) {
			params.current = 1;

			this.containerContent
				.html($preloader);

		} else {
			params.current++;

			this.containerContent
				.append($preloader);
		}

		$.post(dataAjaxPath, params)
			.done(function (data) {
				self.containerContent
					.find('.preloader')
					.remove();

				let json = JSON.parse(data);
				if (json.total > 0) {
					if (firstLoad) {
						self.containerContent
							.html(templateVacancies(json));

						self.container
							.attr('data-vacancies-total', json.total)
							.attr('data-vacancies-current', 1);
					} else {
						self.containerContent
							.append(templateVacancies(json));

						self.container
							.attr('data-vacancies-current', json.current);
					}
				} else {
					self.containerContent
						.html('<p class="news__empty-result">Sorry, there are no results matching your filter criteria</p>');

					self.container
						.attr('data-vacancies-total', 1)
						.attr('data-vacancies-current', 1);
				}

				if (json.current < json.total) {
					self.container
						.find('.js-vacancies-loader')
						.show();
				}
			})
			.fail(function (data) {
				self.containerContent
					.find('.preloader')
					.remove();

				showNotyfications('ajax request failed', {
					type: 'error'
				});

				console.error('ajax request failed');
			});
	}
}

let vacancies = new Vacancies($('.js-vacancies'));
vacancies.create();

$(document).on('touchmove scroll mousewheel DOMMouseScroll', debounce(100, function (e) {
	if (!$('.js-vacancies-content').find('.preloader').length) {
		vacancies.checkScroll(e);
	}
}));



// WEBPACK FOOTER //
// ./frontend/components/vacancies/vacancies.js